"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdultServiceHighRiskDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.AdultServiceHighRiskDescription = {
    priority: 2,
    label: 'fields.payload.mor_group_answers.adult_service_high_risk_description.label',
    fallbackLabel: 'If the response is no, could you please specify the risk classification assigned to merchants in this segment and the frequency of their ongoing due diligence?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_adult_service_segment', 'mor_group_answers.adult_service_is_high_risk', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_adult_service_segment === true
        && payload.mor_group_answers?.adult_service_is_high_risk === false
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_adult_service_segment === true
        && payload.mor_group_answers?.adult_service_is_high_risk === false
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
